import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import validate from "validate.js"
import StarRating from "vue-star-rating";
import Toasted from "vue-toasted";

import vueTopprogress from "vue-top-progress";
import VueFormWizard from './components/vue-form-wizard';
import VueModal from "vue-js-modal";
import './components/vue-form-wizard/dist/vue-form-wizard.min.css';

import FBSignInButton from 'vue-facebook-signin-button';

Vue.use(FBSignInButton)

import ZNumber from "./components/number";

import ZText from "./components/text";

Vue.use(VueFormWizard)
 
Vue.use(vueTopprogress);

Vue.use(Toasted, {
  duration: 5000,
  position: "bottom-right"
});

Vue.use(VueModal);

Vue.config.productionTip = false;

Vue.component('star-rating', StarRating);

Vue.component("z-text", ZText);

Vue.component("z-number", ZNumber);

validate.formatters.custom = function(errors) {
  let data = {};
  for (let error in errors) {
    if (!errors.hasOwnProperty(error)) continue;
    data[errors[error].attribute] = errors[error].error;
  }
  return data;
};

Vue.prototype.$validate = function(object, constraints) {
  return validate(object, constraints, {format: "custom", fullMessages: false});
};

Vue.prototype.$fetch = function(url, method, data) {
    return new Promise((resolve, reject) => {
        fetch(url, {
            method: method || "GET",
            body: JSON.stringify(data),
            mode: "cors",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": store.state.user.auth_token ? store.state.user.auth_token : undefined
            }
        })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
